import React, { FunctionComponent, useState } from 'react'
import * as S from './styled'
import { getAuth, fetchSignInMethodsForEmail } from 'firebase/auth'
import app from '../../firebase/initialize'

import { ReactComponent as Logo } from '../../components/atoms/Icons/logo.svg'
import { ReactComponent as MailIcon } from '../../components/atoms/Icons/mail-icon.svg'
import { ReactComponent as PasswordIcon } from '../../components/atoms/Icons/password-icon.svg'
import { useHistory } from 'react-router'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { MainState } from '../../redux/reducers'
import { requestActions } from '../../redux/requests'

type OwnProps = {}

type Props = OwnProps

export const SignUp: FunctionComponent<Props> = () => {
  const [userName, setUserName] = useState('')
  const [defaultProduct, setDefaultProduct] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState({ error: false, message: '' })
  const [registered, setRegistered] = useState(false)
  const dispatch = useDispatch()
  let uid = useSelector((state: MainState) => state.misc.uid)

  const auth = getAuth()

  const history = useHistory()
  const handleSubmit = async e => {
    e.preventDefault()

    const signInMethods = await fetchSignInMethodsForEmail(auth, email)

    if (signInMethods.length > 0) {
      setError({
        error: true,
        message: 'Denna mail adress används redan!',
      })
    } else if (password.length < 6) {
      setError({
        error: true,
        message: 'Lösenordet måste innehålla minst 6 tecken!',
      })
    } else if (password !== confirmPassword) {
      setError({
        error: true,
        message: 'Båda lösenord måste vara identiska!',
      })
    } else {
      setError({
        error: false,
        message: '',
      })
      dispatch(requestActions.auth.signUp({ email, userName, password, defaultProduct }, dispatch))

      setRegistered(true)
    }
  }
  function changeHandler(event: any) {
    const value = event.target.value
    setDefaultProduct(value)
  }
  return (
    <>
      {!registered ? (
        <S.Wrapper>
          <S.Container>
            <Logo height="150" viewBox="0 0 550 550" />
            <S.FormContainer>
              <S.Title>Registrera</S.Title>
              <S.Form onSubmit={handleSubmit}>
                <S.Label htmlFor={'userName'}>Användarnamn</S.Label>
                <S.InputWrapper>
                  <MailIcon />
                  <S.Input
                    required
                    type="text"
                    name="userName"
                    value={userName}
                    onChange={e => setUserName(e.target.value)}
                  />
                </S.InputWrapper>
                <S.Label>Huvudsaklig Produkt</S.Label>
                <S.SelectStyled required name="" id="" onChange={changeHandler}>
                  <option value="" hidden>
                    Välj Produkt
                  </option>
                  <option value="eggs">Ägg</option>
                  <option value="oats">Havre</option>
                  <option value="raps">Raps</option>
                </S.SelectStyled>
                <S.Label htmlFor={'email'}>Email</S.Label>
                <S.InputWrapper>
                  <MailIcon />
                  <S.Input
                    required
                    type="email"
                    name="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </S.InputWrapper>
                <S.Label htmlFor={'password'}>Lösenord</S.Label>
                <S.InputWrapper>
                  <PasswordIcon />
                  <S.Input
                    type="password"
                    name="password"
                    value={password}
                    onChange={e => {
                      setPassword(e.target.value)
                    }}
                  />
                </S.InputWrapper>
                <S.Label htmlFor={'password'}>Bekräfta Lösenord</S.Label>
                <S.InputWrapper>
                  <PasswordIcon />
                  <S.Input
                    type="password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                  />
                </S.InputWrapper>
                {error.error && (
                  <p style={{ color: '#fd3b37', textAlign: 'end' }}>{error.message}</p>
                )}

                <S.Button color="color">Registrera dig</S.Button>
              </S.Form>
              <S.ButtonNew onClick={() => history.push('/signin')}>Logga in</S.ButtonNew>
            </S.FormContainer>
          </S.Container>
        </S.Wrapper>
      ) : (
        <S.Wrapper>
          <S.Container>
            <Logo height="125" viewBox="0 0 550 550" />
            <S.Title>Tack för att du har registrerat dig!</S.Title>
            <S.Paragraph>
              Verifikationslänk har skickats till <b>{email}</b>.
            </S.Paragraph>
            <S.Paragraph>
              Det kan ta några minuter för att få verifikationsmejlet. Kolla gärna skräppost.
            </S.Paragraph>
            <S.Paragraph>Du måste verifiera din e-post innan du kan logga in.</S.Paragraph>
          </S.Container>
        </S.Wrapper>
      )}
    </>
  )
}

export default SignUp
